export default "__VITE_ASSET__DKOmYUKw__"